export const multiply = (data, fieldsToMultiply) => {
  let result = 1;
  for (const field of fieldsToMultiply) {
    result *= data[field];
  }

  return result
}

export const sum = (data, fieldsToAdd) => {
  let result = 0;

  if (Array.isArray(fieldsToAdd)) {
    for (const field of fieldsToAdd) {
      //Perform operation on the Cents
      result += data[field]*100;
    }

  } else {
    result += data[fieldsToAdd]*100;
  }

  //Return the results with cents...
  return isNaN(result) ? 0 : result/100;
}

export const divide = (data, fieldsToDivide) => {
  let result
  result = data[fieldsToDivide[0]] / data[fieldsToDivide[1]];
  if (isNaN(result)) result = 0;

  const rounded = Math.round(result * 100) / 100;
  return isNaN(rounded) ? 0 : rounded;
}

/**
 * First field minus the rest.
 *
 * Deliberately not the cents trick `sum` uses. Scaling by 100 and back is lossy
 * — 99.99 * 100 / 100 is 99.98999999999998 — which would move `netSalesAmount`
 * on every line that has no discount to subtract. Plain subtraction leaves
 * `x - 0` exactly `x`, and rounds nowhere, which is what `multiply` above
 * already does for the same numbers. Discount figures are rounded where they
 * are computed (36.03 §6), not here.
 */
export const subtract = (data, fieldsToSubtract) => {
  const fields = Array.isArray(fieldsToSubtract) ? fieldsToSubtract : [fieldsToSubtract]

  let result = Number(data[fields[0]]) || 0
  for (const field of fields.slice(1)) {
    result -= Number(data[field]) || 0
  }

  return isNaN(result) ? 0 : result
}

/**
 * The money a discount takes off — the one part of a discount that is not
 * arithmetic, because which form applies is data rather than configuration.
 *
 * Shared by sub.discount and header.discount so a line and a document cannot
 * round differently or disagree about what an unset type means.
 *
 * Rounded here, unlike its neighbours in this file (36.03 §6). A discount is the
 * one figure in the chain a customer reads back off the document, so 10% of
 * 99.99 has to be 10.00 rather than 9.999 — and the document discount's
 * allocation needs exact 2 dp shares before there is a remainder to distribute.
 *
 * No type, or a value that is not a number, is 0 rather than nothing: the
 * subtraction that follows then needs no special case.
 */
export const discount = (type, value, base, decimals = 2) => {
  const factor = 10 ** decimals

  let amount = 0

  if (type === 'percentage' && Number.isFinite(value) && Number.isFinite(base)) {
    amount = base * value / 100
  } else if (type === 'amount' && Number.isFinite(value)) {
    amount = value
  }

  /*
   * A discount larger than what it discounts is deliberately not capped.
   * Clamping at the base would silently return a number the user did not ask
   * for; a total that goes visibly negative does not. Refusing it is a
   * validation question, and validation is a different layer.
   */
  if (!Number.isFinite(amount)) amount = 0

  return Math.round(amount * factor) / factor
}
